module.exports = __webpack_public_path__ + "static/media/selecione_suas_cameras.b97dff13.png";